export default __webpack_public_path__ + "static/email-illustration-84fb82b841c197337a4bc2c1e660d5a0.svg";